import { createRouter, createWebHistory } from "vue-router";
import Offer from "@/views/OfferView.vue";
import Contact from "@/views/ContactView.vue"

const routes = [
  {
    path: '/',
    component: Offer,
    meta: {
      title: 'Oferta'
    }
  },
  {
    path: '/kontakt',
    component: Contact,
    meta: {
      title: 'Kontakt'
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


router.beforeEach((to, from, next) => {
  const prefix = 'Laweta Ostróda | '
  document.title = prefix + to.meta.title
  next();
})

export default router;